import { render, staticRenderFns } from "./CollectFromBorrowers.vue?vue&type=template&id=218933bc&scoped=true"
import script from "./CollectFromBorrowers.vue?vue&type=script&lang=js"
export * from "./CollectFromBorrowers.vue?vue&type=script&lang=js"
import style0 from "./CollectFromBorrowers.vue?vue&type=style&index=0&id=218933bc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "218933bc",
  null
  
)

export default component.exports